import { useMsal } from '@azure/msal-react';
import { useAppUser } from '../auth/AppUserContext';
import { forgetCachedProfile, stopSavingProfiles } from '../auth/profileCache';
import { ActionButton, untilLeaving } from '../ui/ActionButton';

export function NotAuthorizedPage() {
  const { instance, accounts } = useMsal();
  const { groupsOverage } = useAppUser();
  const upn = accounts[0]?.username ?? 'your account';

  return (
    <div className="signin-page">
      <div className="signin-card">
        <h1>Not authorized</h1>
        <p>
          <strong>{upn}</strong> signed in successfully but has no active role
          in SSP AuditPlus. Ask an admin to give you a role (Admin → Users &amp;
          roles).
        </p>
        {groupsOverage && (
          <p className="muted">
            Note: this account is in too many groups for AuditPlus to check
            them at sign-in, so a role given through a group couldn’t be
            applied. An admin can add you directly instead.
          </p>
        )}
        <ActionButton
          className="btn btn-ghost"
          busyLabel="Signing out…"
          onAction={() => {
            stopSavingProfiles();
            for (const a of accounts) forgetCachedProfile(a.username);
            return untilLeaving(instance.logoutRedirect());
          }}
        >
          Sign out
        </ActionButton>
      </div>
    </div>
  );
}
